import * as React from "react"

interface ReportsProps {
  color: string
}

const Reports: React.FC<ReportsProps> = ({ color }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0V15C0 16.0931 0.906937 17 2 17H17V15H2V0H0ZM16.293 2.29297L12 6.58594L9 3.58594L3.29297 9.29297L4.70703 10.707L9 6.41406L12 9.41406L17.707 3.70703L16.293 2.29297Z"
        fill={color}
      />
    </svg>
  )
}

export default Reports
